import { Routes, RouterModule } from '@angular/router';
import { DiscountDetailFrm } from './discount.frm';
import { DiscountList } from './discount.list';

export const routes: Routes = [
    { path: 'page/discountlist', component: DiscountList },
    {
        path: 'discountdetail/:id/:dmy',
        component: DiscountDetailFrm,
        data: { shouldReuseRoute: false },
    },
    { path: '', redirectTo: 'page/discountlist', pathMatch: 'full' },
    {
        path: 'page/discount',
        redirectTo: 'page/discountlist',
        pathMatch: 'full',
    },
];

export const DISCOUNT_ROUTER_PROVIDERS = RouterModule.forRoot(routes);
